import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const issueViewEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-issue-app--full-page", jiraSpaEntry: "spa-issue" */ './src/issue-view-with-redirect.tsx'
			),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: () => ({}),
});
